import { useMemo, useCallback, useState } from 'react';
import find from 'lodash/find';

import { useCourses } from 'modules/courses/hooks';

export default function useCourseSelector({ excludedCourses = [] } = {}) {
  const { courses: allCourses, loading } = useCourses();

  const [selectedCourse, setSelectedCourse] = useState();

  const courses = useMemo(() => {
    if (!excludedCourses || excludedCourses.length === 0) return allCourses;

    return (
      allCourses?.filter((c) => {
        return !excludedCourses.includes(c._id);
      }) || []
    );
  }, [allCourses, excludedCourses]);

  const onSelectCourse = useCallback(
    (selectedCourseId) => {
      const course = find(courses, { _id: selectedCourseId });
      setSelectedCourse(course);
    },
    [courses]
  );

  return {
    selectedCourse,
    props: {
      courses,
      loading,
      selectedCourseId: selectedCourse?._id,

      onSelectCourse,
    },
  };
}
